import { useT } from "@transifex/react";
import { ButtonColorVariant } from "../teacherArea/AreaButton";
import BasePopupWrapper, { TitleColorVariants } from "../../basic/popups/BasePopupWrapper";
import { FormattedText } from "../teacherArea/FormattedText";

export enum ShareConfirmationKinds {
    Single = "single",
    Bulk = "bulk",
}

interface ShareConfirmationPopupProps {
    isOpen: boolean;
    kind: ShareConfirmationKinds;
    studentName?: string;
    testName?: string;
    isSharing: boolean;
    onCancel: () => void;
    onConfirm: () => void;
}

const ShareConfirmationPopup = (props: ShareConfirmationPopupProps) => {
    const t = useT();

    const t_cancel = t("Cancel", { _tags: "ShareTestReviews, ShareConfirmationPopup" });
    const t_confirm = t("Yes, share", { _tags: "ShareTestReviews, ShareConfirmationPopup" });
    const t_titleSingle = t("Share evaluation", { _tags: "ShareTestReviews, ShareConfirmationPopup" });
    const t_titleBulk = t("Share evaluations", { _tags: "ShareTestReviews, ShareConfirmationPopup" });
    const t_classroomLine = t('The results will be visible under "Evaluations" in the classroom.', {
        _tags: "ShareTestReviews, ShareConfirmationPopup",
    });

    const isSingle = props.kind === ShareConfirmationKinds.Single;
    const title = isSingle ? t_titleSingle : t_titleBulk;
    const headline = isSingle
        ? t("Should the evaluation for <b>{studentName}</b> be released?", {
              _tags: "ShareTestReviews, ShareConfirmationPopup",
              studentName: props.studentName ?? "",
          })
        : t('Would you like to release all evaluations for "{testName}"?', {
              _tags: "ShareTestReviews, ShareConfirmationPopup",
              testName: props.testName ?? "",
          });

    return (
        <BasePopupWrapper
            isOpen={props.isOpen}
            onClose={props.onCancel}
            title={title}
            titleColor={TitleColorVariants.DEFAULT}
            primaryButton={{
                text: t_confirm,
                onClick: props.onConfirm,
                disabled: props.isSharing,
                colorVariant: ButtonColorVariant.DEFAULT,
                className: "min-w-[200px]",
            }}
            secondaryButton={{
                text: t_cancel,
                onClick: props.onCancel,
                disabled: props.isSharing,
                colorVariant: ButtonColorVariant.DEFAULT,
                className: "min-w-[200px]",
            }}
        >
            <div className="flex flex-col gap-s">
                <FormattedText
                    rawText={headline}
                    textColor="text-l text-p6-grey-dark [&_b]:font-semibold"
                />
                <p className="text-l text-p6-grey-dark">{t_classroomLine}</p>
            </div>
        </BasePopupWrapper>
    );
};

export default ShareConfirmationPopup;
